shadow$provide[321] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Factory:{enumerable:true, get:function() {
  return require$_DOT__SLASH_factory_DOT_js.PrimitiveFactory;
}}, Types:{enumerable:true, get:function() {
  return Types;
}}});
var types = require("./types");
var require$_DOT__SLASH_factory_DOT_js = require("./factory.js");
var require$_DOT__SLASH_primitive_DOT_js = require("./primitive.js");
require.exportCopy(module, require$_DOT__SLASH_primitive_DOT_js);
const Types = types;

};